import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsFK: CultureInfo = {
  name: 'es-FK',
  displayName: 'español (Islas Malvinas)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-FK',
  parent: CultureInfoEs
};
